// src/pages/Login.js
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/styles/sb-admin-2.min.css";
import "../assets/styles/custom-styles.css";
import LoginCard from "../components/login/LoginCard";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import useNotification from "../hooks/useNotification";
import { Box } from "@mui/material";

const Login = () => {
  const location = useLocation();
  const { showNotification } = useNotification();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const message = searchParams.get("message");

    if (message) {
      showNotification("error", message); // Exibe o alerta com a mensagem da URL
    }
  }, [location, showNotification]);

  return (
    <Box
      className="d-flex align-items-center justify-content-center vh-100"
      sx={{ background: "linear-gradient(90deg, #0d2142 0%, #3478dd 100%)" }}
    >
      <LoginCard />
    </Box>
  );
};

export default Login;
